/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProfileContactResponseEmailType } from './profileContactResponseEmailType';
import type { ProfileContactResponseFeedback } from './profileContactResponseFeedback';
import type { ProfileContactResponseType } from './profileContactResponseType';

export interface ProfileContactResponse {
  id: string;
  source: string;
  type: ProfileContactResponseType;
  value: string;
  email_type?: ProfileContactResponseEmailType;
  deliverability?: string | null;
  carrier?: string | null;
  is_valid?: boolean | null;
  line_type?: string | null;
  revealed_by_name?: string | null;
  feedback?: ProfileContactResponseFeedback;
  created_at: string;
  is_synthetic?: boolean;
}
